// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"PlansCatalog_paginationPageDropdownWrap__fsPSC","plansList":"PlansCatalog_plansList__ZX74K","planButton":"PlansCatalog_planButton__A4+50"};